/** Full-width watercolor band behind middle home sections */
export const HOME_SECTION_BACKGROUND_URL =
  "https://pub-dd11db53b680447d86c08d43682efe32.r2.dev/images/home/section-background.png";
